import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import { Alert, Button, Modal, ModalBody, Progress } from 'reactstrap'
import { UserQuery } from "../Functions/querys"
import withApolloClient from '../withApolloClient'
import DatetimeRenderer from './DatetimeRenderer'
import './NotificationsModal.css'
import Skeleton from 'react-loading-skeleton'

const MarkAllUserNotificationsAsRead = gql`
mutation markAllUserNotificationsAsRead($userId:ID!){
    markAllUserNotificationsAsRead(input:{userId:$userId}){
        ok
        errors{
            messages
            field
        }
    }
}`



const UpdateUserNotification = gql`
mutation UpdateUserNotification($notificationId:ID!, $isRead:Boolean!){
    updateUserNotification(input:{notificationId:$notificationId, isRead:$isRead}){
        ok
        errors{
            messages
            field
        }
    }
}`

const DeleteUserNotification = gql`
mutation DeleteUserNotification($notificationId:ID!){
    deleteUserNotification(input:{notificationId:$notificationId}){
        ok
        errors{
            messages
            field
        }
    }
}`

const NotificationsQuery = gql`
query NotificationsQuery($cursor: String,$first:Int!,$orderBy: [String],$userId:ID!,$isRead:Boolean){
    notifications: allUserNotifications(first:$first,orderBy:$orderBy, after: $cursor,userId:$userId,isRead:$isRead){
        edges{
            cursor
            node{
                id
                message
                title
                isRead
                dateAdded
            }
        }
        pageInfo{
            endCursor
            hasNextPage
        }
    }
}`

class NotificationsModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            markedSuccessfully: false,
            activeTab: 'unread',
            error: "",
            loading: false,
        }
    }

    handleClose = () => {
        this.setState({})
        this.props.handleClose()
    }

    markSingleNotifcationAsReadOrUnRead = (notificationId, isRead) => {
        try {
            this.setState({ loading: true })
            this.props.apolloClient.mutate({
                mutation: UpdateUserNotification,
                variables: { notificationId, isRead },
                refetchQueries: [{ query: UserQuery }],
            }).then(result => {
                if (result.data?.updateUserNotification?.ok) {
                    this.setState({ loading: false, markedSuccessfully: true })
                    this.props.refetchAllUnreadNotifications()
                    this.props.refetchAllNotifications()
                    this.props.refetchUserQuery()
                } else if (result.data?.updateUserNotification?.errors?.length > 0) {
                    this.setState({ loading: false, markedSuccessfully: false, error: result.data.updateUserNotification.errors[0].messages[0] })
                }
            }).catch((e) => {
                console.log(e)
                this.setState({ loading: false, markedSuccessfully: false, error: "An error has occurred." + e.message })

            })
        } catch (err) {
            console.log(err)
            this.setState({ loading: false, markedSuccessfully: false, error: "An error has occurred." + err.message })
        }
    }

    deleteUserNotification = (notificationId) => {
        try {
            this.setState({ loading: true })
            this.props.apolloClient.mutate({
                mutation: DeleteUserNotification,
                variables: { notificationId },
                refetchQueries: [{ query: UserQuery }],
            }).then(result => {
                if (result.data?.deleteUserNotification?.ok) {
                    this.setState({ loading: false, markedSuccessfully: true })
                    this.props.refetchAllUnreadNotifications()
                    this.props.refetchAllNotifications()
                    this.props.refetchUserQuery()
                } else if (result.data?.deleteUserNotification?.errors?.length > 0) {
                    this.setState({ loading: false, markedSuccessfully: false, error: result.data.deleteUserNotification.errors[0].messages[0] })
                }
            }).catch((e) => {
                console.log(e)
                this.setState({ loading: false, markedSuccessfully: false, error: "An error has occurred." + e.message })
            })
        } catch (err) {
            console.log(err)
            this.setState({ loading: false, markedSuccessfully: false, error: "An error has occurred." + err.message })
        }
    }

    markAllAsRead = () => {
        try {
            this.setState({ loading: true })
            let input = {
                userId: this.props.currentUser?.id,
            }
            this.props.apolloClient.mutate({
                mutation: MarkAllUserNotificationsAsRead,
                variables: input,
                refetchQueries: [{ query: UserQuery }],
            }).then(result => {
                if (result.data?.markAllUserNotificationsAsRead?.ok) {
                    this.setState({ loading: false, markedSuccessfully: true })
                    this.props.refetchAllUnreadNotifications()
                    this.props.refetchAllNotifications()
                    this.props.refetchUserQuery()
                } else {
                    this.setState({ loading: false, markedSuccessfully: false, error: "An error has occurred." })
                }
            }).catch(() => {
                this.setState({ loading: false, markedSuccessfully: false, error: "An error has occurred." })
            })
        } catch (err) {
            this.setState({ loading: false, markedSuccessfully: false, error: "An error has occurred." })
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    handleLoadMore = () => {
        if (this.state.activeTab === 'unread') {
            this.props.loadMoreUnreadEntries()
        } else {
            this.props.loadMoreEntries()
        }
    }


    render() {
        const notificationsToRender = this.state.activeTab === 'unread' ? this.props.allUnreadNotifications?.edges || [] : this.props.notifications?.edges || []
        return (
            <Modal
                className='notifications-modal'
                modalClassName="notifications-modal-dialog"
                contentClassName="notifications-modal-content"
                backdropClassName="notifications-modal-backdrop"
                isOpen={this.props.open}
                toggle={this.handleClose}
                backdrop={true}
            >
                <div className="header-wrapper">
                    <div className="header-title" onClick={this.handleClose}>
                        <i className="fa fa-times" aria-hidden="true"></i> Notifications
                    </div>

                    <Button
                        size="sm"
                        className="mark-read-button"
                        onClick={this.markAllAsRead}
                    >
                        Mark all as read
                    </Button>
                </div>
                <div className="tabs-wrapper">
                    <span className={`tab ${this.state.activeTab === 'unread' ? 'active' : ''}`} onClick={() => this.setState({ activeTab: 'unread' })}>Unread</span>
                    <span className={`tab ${this.state.activeTab !== 'unread' ? 'active' : ''}`} onClick={() => this.setState({ activeTab: 'all' })}>All</span>
                </div>
                <ModalBody className="notifications-body">
                    {this.state.error && !this.state.markedSuccessfully && (<Alert color="danger">{this.state.error}</Alert>)}
                    {((this.props.loading || this.state.loading)) ? (
                        [...Array(5)].map((_, i) => (
                            <div key={i}>
                                <Skeleton height={20} width="100%" />
                                <Skeleton height={15} width="80%" />
                            </div>
                        ))
                    ) :
                        <>
                            {notificationsToRender.length === 0 ? (
                                <div className="no-notification-state pt-5">
                                    <i className="fa fa-bell-o no-notification-state-icon" aria-hidden="true" />
                                    <p>{this.state.activeTab === 'unread' ? 'You’re all up to date.' : 'No notifications to show.'}</p>
                                </div>
                            ) : notificationsToRender.map((notification, i) => (
                                <div key={i} className="notification-content">
                                    <div className="text-content">
                                        {/* Title */}
                                        <p className={`message ${notification.node.isRead ? "read" : "unread"}`}>
                                            {!notification.node.isRead && (
                                                <><i className="fa fa-circle" aria-hidden="true" ></i>&nbsp;&nbsp;</>
                                            )}
                                            {notification.node.title && <span>{notification.node.title?.toLocaleUpperCase().slice(0, 100) || "--"}<br /></span>}
                                            {/* {notification.node.message || "--"} */}
                                            <ReactMarkdown>{notification.node.message}</ReactMarkdown>
                                        </p>
                                        <p className='date-content-and-hover-icons'>
                                            <DatetimeRenderer datetime={notification.node.dateAdded} />
                                            <span className="hover-icons">
                                                <i className={notification.node.isRead ? "fa fa-check-circle" : "fa fa-check-circle-o"} title={notification.node.isRead ? "Mark as Unread" : "Mark as Read"} onClick={() => this.markSingleNotifcationAsReadOrUnRead(notification.node.id, !notification.node.isRead)} />
                                                &nbsp;&nbsp;
                                                <i className="fa fa-trash" title="Delete" onClick={() => this.deleteUserNotification(notification.node.id)} />
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                </ModalBody>
                <div className="footer-note">
                    <p>
                        {this.props.currentUser?.unreadNotificationsCount || 0} of {this.props.notifications?.edges?.length} unread notifications
                    </p>
                    {this.props.notifications?.pageInfo?.hasNextPage && <a href="#" onClick={() => this.handleLoadMore()}>Load More</a>}
                </div>
            </Modal>
        )
    }
}
export default graphql(NotificationsQuery, {
    options: ({ currentUser }) => ({
        variables: {
            orderBy: ["-date_added"],
            first: 15,
            userId: currentUser?.id || null,
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    }),
    skip: ({ currentUser }) => !currentUser,
    props: ({ data: { notifications, loading, variables, fetchMore } }) => ({
        notifications,
        loading,
        variables,
        refetchAllNotifications: () => {
            const currentLength = notifications?.edges?.length || 30
            return fetchMore({
                query: NotificationsQuery,
                variables: { ...variables, first: currentLength },
                updateQuery: (prev, { fetchMoreResult }) => {
                    if (!fetchMoreResult?.notifications) return prev
                    const newEdges = fetchMoreResult.notifications.edges || []
                    const pageInfo = fetchMoreResult.notifications.pageInfo
                    return {
                        notifications: {
                            edges: [...newEdges],
                            pageInfo,
                            __typename: prev.notifications?.__typename || fetchMoreResult.notifications.__typename,
                        },
                    }
                },
            })
        },
        loadMoreEntries: () => {
            const endCursor = notifications?.pageInfo?.endCursor || null
            if (!endCursor) return Promise.resolve()
            return fetchMore({
                query: NotificationsQuery,
                variables: {
                    ...variables,
                    cursor: endCursor,
                },
                updateQuery: (prev, { fetchMoreResult }) => {
                    if (!fetchMoreResult?.notifications) return prev
                    const prevEdges = prev?.notifications?.edges || []
                    const newEdges = fetchMoreResult.notifications.edges || []
                    const pageInfo = fetchMoreResult.notifications.pageInfo
                    return {
                        notifications: {
                            edges: [...prevEdges, ...newEdges],
                            pageInfo,
                            __typename: prev.notifications?.__typename || fetchMoreResult.notifications.__typename,
                        },
                    }
                },
            })
        },
    }),
})(
    graphql(NotificationsQuery, {
        options: ({ currentUser }) => ({
            variables: {
                orderBy: ["-date_added"],
                isRead: false,
                first: 15,
                userId: currentUser?.id || null,
            },
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
        }),
        skip: ({ currentUser }) => !currentUser,
        props: ({ data: { notifications: allUnreadNotifications, loading: loadingUnread, variables: variablesUnread, fetchMore: fetchMoreUnread } }) => ({
            allUnreadNotifications,
            loadingUnread,
            variablesUnread,
            refetchAllUnreadNotifications: () => {
                const currentLength = allUnreadNotifications?.edges?.length || 30
                return fetchMoreUnread({
                    query: NotificationsQuery,
                    variables: { ...variablesUnread, first: currentLength },
                    updateQuery: (prev, { fetchMoreResult }) => {
                        if (!fetchMoreResult?.notifications) return prev
                        const newEdges = fetchMoreResult.notifications.edges || []
                        const pageInfo = fetchMoreResult.notifications.pageInfo
                        return {
                            notifications: {
                                edges: [...newEdges],
                                pageInfo,
                                __typename: prev.notifications?.__typename || fetchMoreResult.notifications.__typename,
                            },
                        }
                    },
                })
            },
            loadMoreUnreadEntries: () => {
                const endCursor = allUnreadNotifications?.pageInfo?.endCursor || null
                if (!endCursor) return Promise.resolve()
                return fetchMoreUnread({
                    query: NotificationsQuery,
                    variables: {
                        ...variablesUnread,
                        cursor: endCursor,
                    },
                    updateQuery: (prev, { fetchMoreResult }) => {
                        if (!fetchMoreResult?.notifications) return prev
                        const prevEdges = prev?.notifications?.edges || []
                        const newEdges = fetchMoreResult.notifications.edges || []
                        const pageInfo = fetchMoreResult.notifications.pageInfo
                        return {
                            notifications: {
                                edges: [...prevEdges, ...newEdges],
                                pageInfo,
                                __typename: prev.notifications?.__typename || fetchMoreResult.notifications.__typename,
                            },
                        }
                    },
                })
            },
        }),
    })(withApolloClient(NotificationsModal))
)
